<template>
  <div class="loader">
    <div class="loader-header">
      <GFMP :wrapper-styles="{ width: '60%' }" :styles="{ ...fmpStyles.rounded }" />
      <GFMP :wrapper-styles="{ width: '5%' }" :styles="{ ...fmpStyles.rounded }" />
    </div>
    <carousel :per-page="perPageCustomProps" :navigation-enabled="false" :pagination-enabled="false">
      <slide v-for="i in perPageCustomProps * 4" :key="i">
        <ProductCardLoader />
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {
  name: 'list-product-slide-loader',
  components: { ProductCardLoader: () => import('../../global/loader/product-card-loader') },
  props: {
    perPageCustomProps: {
      type: Number,
      required: false,
      default: () => 6,
    },
  },
  data() {
    return {
      fmpStyles: {
        rounded: {
          borderRadius: '8px',
          height: '12px',
        },
        circle: {
          borderRadius: '50%',
          height: '12px',
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';

.loader {
  display: flex;
  flex-direction: column;
  gap: 32px;

  &-header {
    display: flex;
    justify-content: space-between;
  }

  & .VueCarousel-slide {
    padding: 0 4px;
  }
}
</style>
